module.exports = __webpack_public_path__ + "static/assets/42115bff255b99bc4dee27f8bc64153c.svg";